import { Seller } from '../seller';
export class Device {
    constructor(
        public id?: number,
        public sn?: string,
        public activated?: boolean,
        public activationDate?: any,
        public activatedFromIp?: string,
        public seller?: Seller,
    ) {
        this.activated = false;
    }
}
export class DeviceReport {
    constructor(
        public sn?: string,
        public message?: boolean,
        public status?: any
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/device/device.model.ts